/**
 * @file SavedCards.ts
 * @brief Saved Cards' own icon: two cards, one behind the other (CreditCard still means billing).
 *
 * @details
 * Mirrors the mobile app's `FRONTEND/src/shared/components/icons/SavedCards.ts`
 * (DES 08-10-2026, app-specific icons): identical geometry and keys, built
 * with lucide-react's `createLucideIcon` so it takes the same props
 * (size, className, strokeWidth, color) as every lucide icon.
 *
 * @author DES
 * @date 08-10-2026
 */

import { createLucideIcon } from "lucide-react";

export const SavedCards = createLucideIcon("SavedCards", [
  ["rect", { x: "2", y: "9", width: "16", height: "11", rx: "2", key: "front" }],
  ["path", { d: "M2 13h16", key: "stripe" }],
  // The card behind: only the edges that show past the front one.
  ["path", { d: "M6 9V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-2", key: "back" }],
]);

export default SavedCards;
